import { ChevronRight } from "lucide-react";
import { LogoIcon } from "../../../../header/Header";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const TrendCastBanner = () => {
    const navigate = useNavigate();
    const handleSeeMore = useCallback(() => {
    navigate(
        `/cities/nairobi/restaurants?name=${encodeURIComponent(
        "Nairobi"
        )}&page=1`
    );
    }, [navigate]);
    return (
        <div className="w-full bg-gradient-to-br from-gray-950 via-gray-900 to-black p-2 flex items-center justify-center rounded-2xl overflow-hidden shadow-2xl">
        <div className="w-full max-w-7xl bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden shadow-2xl">
            
            {/* Parent flex container controlling height */}
            <div className="flex flex-col lg:flex-row items-stretch w-full min-h-[350px] lg:min-h-[450px]">

                {/* Left Side - Hero Image */}
                <div className="w-full lg:w-1/2 relative flex-1 overflow-hidden rounded-t-2xl lg:rounded-l-2xl lg:rounded-tr-none">
                
                {/* Base image */}
                <img 
                    src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&q=80" 
                    alt="Trending restaurant"
                    className="w-full h-full object-cover opacity-60"
                />

                {/* Shiny hover effect */}
                <div className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500 bg-gradient-to-tr from-transparent via-white/20 to-transparent pointer-events-none" />
                </div>

            {/* Right Side - Content */}
            <div className="w-full lg:w-1/2 flex-1 bg-gradient-to-br from-gray-950 via-gray-900 to-black p-4 sm:p-6 md:p-8 lg:p-10 flex flex-col justify-center relative overflow-hidden">

                {/* Background decorations */}
                <div className="absolute top-0 right-0 w-72 h-72 bg-gradient-to-br from-purple-500/10 via-pink-500/10 to-orange-400/10 rounded-full blur-3xl" />
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-orange-400/10 via-pink-500/10 to-purple-500/10 rounded-full blur-3xl" />

                <div className="relative z-10">
                {/* Logo */}
                <div className="flex items-center gap-2 mb-3">
                    <div className="flex items-center gap-2">
                        <LogoIcon size={8} />
                    <span className="text-white text-lg sm:text-xl md:text-2xl font-bold">Gemio</span>
                    </div>
                    <span className="text-gray-300 text-xs sm:text-sm md:text-base">Insights</span>
                </div>

                {/* Main Heading */}
                <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-3">
                    Trending Restaurants in <br /> Nairobi
                </h1>

                {/* Subtitle */}
                <p className="text-gray-300 text-base sm:text-lg md:text-xl mb-5 max-w-md leading-relaxed">
                    Treat yourself this week, these are worth checking out in Nairobi.
                </p>

                {/* CTA Button */}
                <button className="group bg-white hover:bg-gray-100 text-gray-900 font-semibold px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-sm sm:text-base md:text-lg transition-all duration-300 hover:shadow-2xl hover:shadow-purple-500/20 hover:scale-105 flex items-center gap-2 w-fit" onClick={handleSeeMore}>
                    <span>Dive in</span>
                    <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>

                {/* Decorative gradient line */}
                <div className="mt-5 sm:mt-6 md:mt-8 h-1 w-24 sm:w-32 bg-gradient-to-r from-purple-500 via-pink-500 to-orange-400 rounded-full shadow-lg shadow-pink-500/50" />
                </div>
            </div>

            </div>
        </div>
        </div>
    );
};

export default TrendCastBanner;
